import ThirdPartyServiceModel from "../../../models/thirdparty/ThirdPartyServiceModel";
import ThirdPartyServiceForm, {ThirdPartyServiceFormBody} from "../ThirdPartyServiceForm";
import {useTranslation} from "react-i18next";
import HTMLTextInput from "../../common/HTMLTextInput/HTMLTextInput";
import React from "react";
import Collapsable from "../../common/Collapsable/Collapsable";
import Checkbox from "../../common/Checkbox/Checkbox";
import {InputTableV2} from "../../common/InputTable/InputTable";

const initialState = {
    type: ThirdPartyServiceModel.Type.GEN_AI,
    serviceName: '',
    enabled: true,
    description: '',
    whitelistedCertFingerprints: [],

    url: 'https://api.example.com/v1',
    model: '',
    disableSystemRole: false,
    customParameters: [
    ],

    authenticationScope: ThirdPartyServiceModel.AuthenticationScope.SERVICE,
    authenticationMethod: ThirdPartyServiceModel.AuthenticationMethod.API_KEY,
    authenticationServiceId: null
};
const allowedAuthenticationMethods = [
    ThirdPartyServiceModel.AuthenticationMethod.API_KEY,
    ThirdPartyServiceModel.AuthenticationMethod.BEARER_TOKEN,
    ThirdPartyServiceModel.AuthenticationMethod.CUSTOM_HEADER,
    ThirdPartyServiceModel.AuthenticationMethod.NONE

];

const customParameterDefaultRow = [{value: ''}, {value: ''}];

function GenAiServiceForm() {
    return (
        <ThirdPartyServiceForm initialState={initialState} FormBody={GenAiServiceFormBody}/>
    )
}

export function GenAiServiceFormBody(props) {
    return (
        <ThirdPartyServiceFormBody {...props} FormBody={FormBody}
            allowedAuthenticationMethods={allowedAuthenticationMethods}/>
    )
}

function FormBody(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        setState,
        toggleHandler,
        inputHandler,
        isDisabled
    } = props;

    const isModelDisabled =  thirdPartyService.url.endsWith("/completions");

    function setCustomParameters(updateCb) {
        setState(state => ({
            ...state,
            customParameters: updateCb(state.customParameters)
        }));
    }

    return (
        <>
            <Collapsable label={t('thirdPartyService:label.genAiSettings')} isDisabled={isDisabled}>
                <div className="display-input">
                    <HTMLTextInput label={t('thirdPartyService:label.url')} name={'url'}
                        value={thirdPartyService.url} onChange={inputHandler} isDisabled={isDisabled} isRequired/>
                    <HTMLTextInput label={t('thirdPartyService:label.model')} name={'model'}
                                   value={thirdPartyService.model} onChange={inputHandler} isDisabled={isDisabled || isModelDisabled} isRequired/>

                    <Checkbox label={t('thirdPartyService:label.disableSystemRole')} name={"disableSystemRole"}
                              checked={thirdPartyService.disableSystemRole} onClick={toggleHandler} isDisabled={isDisabled}/>

                </div>
            </Collapsable>
            <Collapsable label={t('thirdPartyService:label.customParameters')} isDisabled={isDisabled}>
                <InputTableV2 ariaLabelKey={'Property'} label={t('thirdPartyService:label.parameters')}
                              headers={[{value: t('thirdPartyService:header.name')}, {value: t('thirdPartyService:header.value')}]}
                              defaultRow={customParameterDefaultRow} inputTable={thirdPartyService.customParameters}
                              setInputTable={setCustomParameters} isDisabled={isDisabled}/>
            </Collapsable>
        </>
    )
}

export default GenAiServiceForm;
